import { Box, Stack } from '@mui/material';
import { ButtonWrapper } from '../../../../../shared/components/formUtilities/useButton';
import CheckIcon from '@mui/icons-material/Check';
import { TextWrapper } from '../../../../../shared/components/formUtilities/useTextWrapper';
import { useTranslation } from 'react-i18next';
import { CURRENCY, IS_SA } from '../../../../../config/appConfig';
import { currencyFormatterHelper } from '../../../../../helpers/currencyFormatterHelper';

export const WithdrawSuccess = ({ amount = 0, onDone = () => { }, isAllowShowPopup = false }) => {
	const { t } = useTranslation();

	const isShowPopupId = () => {
		return amount && isAllowShowPopup;
	};

	return (
		<Box className="flex flex-0 justify-center" id={`${isShowPopupId() ? `success_withdraw_popup_${IS_SA ? 'ksa' : 'uae'}` : ''}`}>
			<Box className="flex flex-col items-center md:w-[670px] w-full">
				<Stack gap={3}>
					<Box className="flex flex-col flex-0" >
						<TextWrapper
							classList="caption !text-sm "
							text={t('youHaveMadeFollowingTransferIntoAccount')}></TextWrapper>
						<TextWrapper
							classList="caption !text-sm !mt-2"
							text={t('withdrawSuccessText')}></TextWrapper>
					</Box>
					<Stack gap={2}>
						<Box className="grid grid-cols-2 gap-4">
							<TextWrapper
								classList="!text-sm !font-bold !text-end"
								text={t('amount')}></TextWrapper>
							<TextWrapper
								classList="!text-sm border-b currency-symbol"
								text={`${CURRENCY} ${currencyFormatterHelper(amount)}`}></TextWrapper>
						</Box>
					</Stack>

					<Box className="flex-col flex justify-center items-center">
						<Stack
							gap={1}
							direction={'row'}
							className="justify-center">
							<ButtonWrapper
								onClick={() => {
									onDone();
								}}
								label={t('done')}
								icon={<CheckIcon></CheckIcon>}></ButtonWrapper>
						</Stack>
					</Box>
				</Stack>
			</Box>
		</Box>
	);
};
